module.exports = __webpack_public_path__ + "img/paper02.2f042ec3.jpeg";